import React from 'react';
import ButtonIconBase from './ButtonIconBase';
import classNames from 'classnames';

function ButtonIcon(props) {
    let buttonClasses = classNames('btn-default', props.className);

    return <ButtonIconBase {...props} className={buttonClasses} />;
}

ButtonIcon.propTypes = {
    ...ButtonIconBase.propTypes
};

ButtonIcon.defaultProps = {
    ...ButtonIconBase.defaultProps
};

export default ButtonIcon;
